(function() {
	'use strict';
	var fromUrl = '/lp-safe-emailing',
		toUrl = '/secure-vpn';

	if (avastGlobals.detect.os.isIOS) {
		window.location.pathname = window.location.pathname.replace(fromUrl, toUrl);
	}

})();
